var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5932 15.4057L14.9262 13.4353C14.775 13.3507 14.2624 13.4548 14.2624 13.6304V17.4802C14.2624 17.6493 14.775 17.7598 14.9196 17.6753L18.7443 15.8024C18.902 15.7179 18.7443 15.4967 18.5866 15.4122L18.5932 15.4057Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1682 0C7.51993 0 0.507965 6.93875 0.507965 15.4967C0.507965 24.0548 7.51993 30.9935 16.1682 30.9935C24.8165 30.9935 31.8285 24.0548 31.8285 15.4967C31.8285 6.93875 24.8165 0 16.1682 0ZM23.7716 17.4607C23.7716 19.288 22.2799 20.7642 20.4332 20.7642H11.8966C10.05 20.7642 8.55825 19.288 8.55825 17.4607V13.5328C8.55825 11.7055 10.05 10.2293 11.8966 10.2293H20.4332C22.2799 10.2293 23.7716 11.7055 23.7716 13.5328V17.4607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a8dcb4a0cf8d4b6ba7f61b637a58cfae.svg";
export { ForwardRef as ReactComponent };